import { t } from '@lingui/core/macro';
import { CarSpec } from 'noddi-types';
import { NoddiButton, NoddiDialog } from 'noddi-ui-web';
import { formatLicensePlate } from 'noddi-util';

type RemoveCarDialogProps = {
  car: CarSpec | null;
  open: boolean;
  onClose: () => void;
  removeCar: (car: CarSpec) => void;
};

export const RemoveCarDialog = ({ car, open, onClose, removeCar }: RemoveCarDialogProps) => {
  const handleConfirmRemove = () => {
    if (car) {
      removeCar(car);
      onClose();
    }
  };

  return (
    <NoddiDialog
      open={open}
      onClose={onClose}
      title={t`Remove car from booking`}
      description={t`Are you sure you want to remove this car from your booking?`}
      footer={
        <div className='flex justify-end gap-2'>
          <NoddiButton variant='outline' onClick={onClose}>
            {t`Cancel`}
          </NoddiButton>
          <NoddiButton onClick={handleConfirmRemove}>{t`Confirm`}</NoddiButton>
        </div>
      }
    >
      {car && (
        <div className='flex flex-col rounded-sm border p-3'>
          <span>
            {car.make} - {car.model}
          </span>
          <span className='text-muted-foreground'>{formatLicensePlate(car.licensePlate.number)}</span>
        </div>
      )}
    </NoddiDialog>
  );
};
